<template>
  <dialog-d
    :title="action.description"
    v-model="dialog"
    @close="$emit('close')"
    confirmation
    @confirm="$emit('input',false)"
  >
    <table-dynamic
      v-if="action.response == 'Grid' && response"
      :items="response"
      :title="action.description"
    ></table-dynamic>
    <v-card-text v-if="action.response == 'Message' && response">{{response}}</v-card-text>
  </dialog-d>
</template>

<script>
export default {
    name: 'action-response-content',
    props: ['value', 'action', 'response'],
    data() {
        return {
            dialog: false
        }
    },
    watch: {
        value() {

            if (this.value == true && (this.action.response == 'Grid' || this.action.response == 'Message')) {
                this.dialog = this.value;
                return;
            } else if (this.value == true && this.action.response == 'Link') {
                this.dialog = false;
                window.open(this.response, "_blank")
                return;
            }

            this.dialog = this.value;
        }
    },
    mounted() {
        this.dialog = this.value;
    }

}
</script>

<style>

</style>
